import { Injectable, signal, TemplateRef } from '@angular/core';

export interface Toast {
	text?: string; // Add this property for string-based toasts
	template?: any; // For template-based toasts
	classname?: string; // Optional CSS class for styling
	delay?: number; // Optional delay for auto-hide
}

@Injectable({ providedIn: 'root' })
export class ToastService {
	private readonly _toasts = signal<Toast[]>([]);
	readonly toasts = this._toasts.asReadonly();
    // toasts: any[] = [];

	show(textOrTpl: string | TemplateRef<any>, options: any = {}): void {
		if (typeof textOrTpl === 'string') {
			this._toasts.update((toasts) => [...toasts, { text: textOrTpl, ...options }]);
		} else {
			this._toasts.update((toasts) => [...toasts, { template: textOrTpl, ...options }]);
		}
	}

	remove(toast: Toast) {
		this._toasts.update((toasts) => toasts.filter((t) => t !== toast));
	}

	clear() {
		this._toasts.set([]);
	}
}